import React from 'react';

import logo from 'assets/img/logo-white-new.svg';

export const Logo: React.FC = () => {
  return (
    <img
      src={logo}
      alt='PDFGuru logo'
      className='w-[132px] h-fit'
    />
  );
};
